import axios from 'axios';

// 設定 request interceptor
axios.interceptors.request.use(
    function (config) {
        var token = localStorage.getItem('X-Auth-Token');
        //console.log("authInterceptor token:", token, "for url:", config.url);

        if (token) {
            //config.headers['X-Auth-Token'] = token;
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);


// WEBPACK FOOTER //
// ./src/axios-interceptor.js